import React, { useState } from 'react';
import { XIcon, ChevronLeftIcon } from 'lucide-react';
import { CollectionDetailsStep } from './steps/CollectionDetailsStep';
import { ProductSelectionStep } from './steps/ProductSelectionStep';
import { ReviewStep } from './steps/ReviewStep';
import { StepIndicator } from './steps/StepIndicator';
interface CreateCollectionModalProps {
  onClose: () => void;
  onCreate: (collection: {
    name: string;
    displaySequence: number;
    isPopular: boolean;
    type: string;
    description?: string;
    products?: any[];
  }) => void;
}
export const CreateCollectionModal = ({
  onClose,
  onCreate
}: CreateCollectionModalProps) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    name: '',
    displaySequence: 10,
    isPopular: false,
    type: 'spu',
    description: '',
    products: []
  });
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedSKUs, setSelectedSKUs] = useState([]);
  const updateFormData = data => {
    setFormData({
      ...formData,
      ...data
    });
  };
  const handleNextStep = () => {
    setCurrentStep(prev => Math.min(prev + 1, 3));
  };
  const handlePrevStep = () => {
    setCurrentStep(prev => Math.max(prev - 1, 1));
  };
  const handleSubmit = () => {
    const products = formData.type === 'sku' ? selectedSKUs : formData.type === 'spu' ? selectedProducts : [...selectedProducts, ...selectedSKUs];
    onCreate({
      ...formData,
      products
    });
  };
  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return <CollectionDetailsStep formData={formData} updateFormData={updateFormData} onNext={handleNextStep} onCancel={onClose} data-id="element-154" />;
      case 2:
        return <ProductSelectionStep collectionType={formData.type} selectedProducts={selectedProducts} setSelectedProducts={setSelectedProducts} selectedSKUs={selectedSKUs} setSelectedSKUs={setSelectedSKUs} onNext={handleNextStep} onBack={handlePrevStep} onSkip={handleNextStep} data-id="element-155" />;
      case 3:
        return <ReviewStep formData={formData} selectedProducts={selectedProducts} selectedSKUs={selectedSKUs} onBack={handlePrevStep} onSubmit={handleSubmit} onSaveDraft={() => {
          // Save as draft functionality would go here
          handleSubmit();
        }} data-id="element-156" />;
      default:
        return null;
    }
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" data-id="element-157">
      <div className="bg-white rounded-lg shadow-lg w-[80%] h-[90vh] flex flex-col" data-id="element-158">
        <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-159">
          <div className="flex items-center" data-id="element-160">
            {currentStep > 1 && <button onClick={handlePrevStep} className="mr-4 text-gray-500 hover:text-gray-700" data-id="element-161">
                <ChevronLeftIcon className="h-5 w-5" data-id="element-162" />
              </button>}
            <h2 className="text-xl font-semibold text-gray-900" data-id="element-163">
              Create Collection
            </h2>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500" data-id="element-164">
            <XIcon className="h-6 w-6" data-id="element-165" />
          </button>
        </div>
        <StepIndicator currentStep={currentStep} data-id="element-166" />
        <div className="flex-1 overflow-y-auto" data-id="element-167">{renderStepContent()}</div>
      </div>
    </div>;
};